import React from 'react';
import { ProfileWidget } from './widget';

export const ProfilePage: React.FC = () => <ProfileWidget />;

